export default __webpack_public_path__ + "static/media/THE-NAIL-BOX-01.98eeb656.png";